var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('div',{staticClass:"page-loading"},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-box"},[_c('i',{staticClass:"el-icon-loading"})])
}]

export { render, staticRenderFns }